import IconWrapper from './icon-wrapper';

const normalIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 10.2561C3.50442 10.8738 1 12.5407 1 14.5C1 16.9853 5.02944 19 10 19C14.9706 19 19 16.9853 19 14.5C19 12.5407 16.4956 10.8738 13 10.2561V12.2918C13.9625 12.4884 14.8005 12.7724 15.4695 13.1069C16.8856 13.8149 17 14.423 17 14.5C17 14.577 16.8856 15.1851 15.4695 15.8931C14.1731 16.5414 12.2421 17 10 17C7.75788 17 5.82691 16.5414 4.53047 15.8931C3.1144 15.1851 3 14.577 3 14.5C3 14.423 3.1144 13.8149 4.53047 13.1069C5.19948 12.7724 6.03747 12.4884 7 12.2918V10.2561Z"
      fill="#595959"
    />
    <path
      d="M7.2024 2.05957C7.09062 1.47058 7.43986 0.909625 7.98246 0.80665C8.52506 0.703674 9.05554 1.09767 9.16732 1.68667L11.3937 13.4178C11.5055 14.0068 11.1562 14.5678 10.6136 14.6708C10.071 14.7737 9.54054 14.3797 9.42876 13.7907L7.2024 2.05957Z"
      fill="#595959"
    />
    <path
      d="M9.15137 1.60266L10.3379 7.8547L13.2262 7.64534C14.9364 7.52137 16.5612 6.84935 17.8593 5.72899L18.1805 5.45175C18.864 4.8619 18.3261 3.7478 17.4392 3.91613C16.0248 4.18455 14.5622 4.01432 13.2472 3.42824L9.15137 1.60266Z"
      fill="url(#paint0_linear_3705_8529)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3705_8529"
        x1="9.99041"
        y1="6.02375"
        x2="18.8326"
        y2="4.34567"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B9B9B9" />
        <stop offset="1" stopColor="#7B7B7B" stopOpacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
);

const activedIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 10.2561C3.50442 10.8738 1 12.5407 1 14.5C1 16.9853 5.02944 19 10 19C14.9706 19 19 16.9853 19 14.5C19 12.5407 16.4956 10.8738 13 10.2561V12.2918C13.9625 12.4884 14.8005 12.7724 15.4695 13.1069C16.8856 13.8149 17 14.423 17 14.5C17 14.577 16.8856 15.1851 15.4695 15.8931C14.1731 16.5414 12.2421 17 10 17C7.75788 17 5.82691 16.5414 4.53047 15.8931C3.1144 15.1851 3 14.577 3 14.5C3 14.423 3.1144 13.8149 4.53047 13.1069C5.19948 12.7724 6.03747 12.4884 7 12.2918V10.2561Z"
      fill="#2D64FF"
    />
    <path
      d="M7.2024 2.05957C7.09062 1.47058 7.43986 0.909625 7.98246 0.80665V0.80665C8.52506 0.703674 9.05554 1.09767 9.16732 1.68667L11.3937 13.4178C11.5055 14.0068 11.1562 14.5678 10.6136 14.6708V14.6708C10.071 14.7737 9.54054 14.3797 9.42876 13.7907L7.2024 2.05957Z"
      fill="#2D64FF"
    />
    <path
      d="M9.15137 1.60266L10.3379 7.8547L13.2262 7.64534C14.9364 7.52137 16.5612 6.84935 17.8593 5.72899L18.1805 5.45175C18.864 4.8619 18.3261 3.7478 17.4392 3.91613C16.0248 4.18455 14.5622 4.01432 13.2472 3.42824L9.15137 1.60266Z"
      fill="url(#paint0_linear_3705_8541)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3705_8541"
        x1="8.91472"
        y1="5.71897"
        x2="19.6777"
        y2="3.4947"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B3EE" />
        <stop offset="1" stopColor="#2BCAFF" stopOpacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
);

export default function IconPlatformMarketing() {
  return <IconWrapper normalIcon={normalIcon} activedIcon={activedIcon} />;
}
